<div class="modal-header">
    <h3 class="modal-title">Clock In</h3>
</div>
<div class="modal-body">
    <div class="row" style="margin-bottom: 12px;">
        <div class="col-md-12 mb-2" *ngIf="lineTypes.length > 1" >
            <strong>Type:</strong>
            <ng-select [(ngModel)]="formData.lineType" 
                       name="lineTypeDropDown" 
                       (change)="typeChanged()"
                       [clearable]="false">
                <ng-option *ngFor="let data of lineTypes" [value]="data.Value">{{data.DisplayValue}}</ng-option>
            </ng-select>
        </div>
        <ng-container [ngSwitch]="formData.lineType">
            <ng-container *ngSwitchCase="'J'">
                <div class="col-md-12">
                    <strong>Job:</strong>
                    <ng-select bindLabel="DisplayValue"
                               [searchable]="true"
                               [(ngModel)]="formData.selectedJob"
                               (change)="jobChanged()"
                               [clearable]=false
                               dropdownPosition="bottom">
                        <ng-option *ngFor="let job of jobs" [value]="job">{{job.DisplayValue}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-12" style="margin-top:10px;">
                    <strong>Phase:</strong>
                    <ng-select bindLabel="PhaseDescription"
                               [searchable]="true"
                               [(ngModel)]="formData.selectedPhase"
                               [clearable]=false
                               dropdownPosition="bottom">
                        <ng-option *ngFor="let phase of phases" [value]="phase">
                            <div>{{phase.PhaseDescription}}</div>
                        </ng-option>
                    </ng-select>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'S'">
                <div class="col-md-12">
                    <strong>Trip:</strong>
                    <ng-select [(ngModel)]="formData.workOrder"
                               [items]="workOrderList"
                               bindLabel="Display"
                               (change)="workOrderChanged()"
                               [searchable]="true" [clearable]="false" dropdownPosition="bottom">
                    </ng-select>
                </div>
                <div class="col-md-12" style="margin-top:10px;">
                    <strong>Scope:</strong>
                    <ng-select [(ngModel)]="formData.scope"
                               [items]="scopeList"
                               bindLabel="Display"                              
                               [searchable]="false" [clearable]="false" dropdownPosition="bottom">
                    </ng-select>
                </div>
                <div class="col-md-12" style="margin-top:10px;">
                    <strong>Pay Type:</strong>
                    <ng-select [(ngModel)]="formData.payType"
                               [items]="payTypeList"
                               bindLabel="Display"
                               [searchable]="false" [clearable]="false" dropdownPosition="bottom">
                    </ng-select>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default"
            (click)="cancelClicked()">
        Cancel
    </button>
    <button type="button" class="btn btn-success" [disabled]="disableClockinButton()"
            (click)="clockInClicked()">
        Clock In
    </button>
</div>
